import { User } from '../Types/User';
import { getApiInstance } from './Api';
import { mapUser } from './UserApi';
import { StudentInput } from './ParentApi';

export enum VoucherType {
  UNLIMITED_SUBSCRIPTION = 'Unlimited Subscription',
  SEVEN_DAYS_SUBSCRIPTION = 'Seven Days Subscription',
  ONE_MONTH_SUBSCRIPTION = 'One Month Subscription',
  YEARLY_SUBSCRIPTION = 'One Year Subscription',
}

interface CreateCheckoutSessionInput {
  voucherType: VoucherType;
  successUrl: string;
  cancelUrl: string;
}
interface CreateCheckoutSessionOutput {
  redirectUrl: string;
}

export class PaymentApi {
  async createCheckoutSession(
    input: CreateCheckoutSessionInput,
  ): Promise<CreateCheckoutSessionOutput> {
    const response = await getApiInstance().post(`/payment`, input);
    return {
      redirectUrl: response.data.redirectUrl,
    };
  }
}
